import ReactGA from 'react-ga4';

import type { GoogleAnalyticsButton, GoogleAnalyticsPage } from 'src/constants';
import type { IGoogleAnalyticsEvent } from 'src/interfaces';

export const getGoogleAnalyticsEvent = (
  page: GoogleAnalyticsPage,
  button: GoogleAnalyticsButton
): IGoogleAnalyticsEvent => {
  return { page, button };
};

export const sendGoogleAnalyticsEvent = ({ page, button }: IGoogleAnalyticsEvent) => {
  ReactGA.event(`bttn_${button}`, { page });
};
